import React from 'react';
import Image from 'next/image';

import { footerBg } from './images';
import {
  DescriptionSection,
  FooterBottom,
  NavigationLinks,
} from './components';

export default function Footer(): React.ReactNode {
  return (
    <footer className='relative overflow-hidden bg-gray-950 print:hidden'>
      <div className='mx-auto max-w-7xl px-4 pt-16 pb-8 sm:px-6 sm:pt-16 md:pt-16 lg:px-8'>
        <div className='flex flex-col items-start gap-y-10 md:gap-y-10 lg:flex-row'>
          <DescriptionSection />
          <NavigationLinks />
        </div>
        <FooterBottom />
      </div>
      <Image
        src={footerBg}
        alt='bg_vector'
        className='absolute -top-32 left-0 h-[30rem] opacity-50 sm:h-auto'
      />
    </footer>
  );
}
